/* @flow strict */

import * as React from 'react';
import RefundBody from './body';
import { GET, POST } from '/client/src/api';
import EventPageDetailCustomersPaymentModal from './paymentModal';
import RefundAllEmailModal from './refundAllEmailModal';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import SimpleCheckbox from '/client/src/components/forms/checkbox';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import RefundAllBanner from './refundAllBanner';

import './styles.scss';

type RefundAllModalContentPropsType = {
  handleRefundAll: () => void,
  confirmWord: string,
  emailData: any
};

const RefundAllModalContent = ({
  handleRefundAll,
  confirmWord,
  emailData
}: RefundAllModalContentPropsType): React.Element<'div'> => {
  const [confirmWordInput, setConfirmWordInput] = React.useState('');
  const [checkbox1, setCheckbox1] = React.useState(false);
  const [checkbox2, setCheckbox2] = React.useState(false);

  const handleConfirmWord = (e: any) => {
    const confirmWordUpperCase = confirmWord.toUpperCase();

    if (
      confirmWord[confirmWordInput.length] === e.key ||
      ((!!window.event.shiftKey || e.getModifierState('CapsLock')) && confirmWordUpperCase[confirmWordInput.length] === e.key)
    ) {
      setConfirmWordInput(prevState => prevState + e.key.toLowerCase());
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleConfirmWord);
    return () => {
      document.removeEventListener('keydown', handleConfirmWord);
    };
  });

  const isValid = _.toLower(confirmWordInput) === confirmWord && checkbox1 && checkbox2;

  return (
    <>
      <div>You are about to refund all tickets for this event. Once confirmed, this action can not be reversed. This action might take a while, we will notify you by email when it is done.</div>
      <ul className='refund-all-confirmation-checkbox-area'>
        <li>
          <SimpleCheckbox
            label='I want to refund all tickets to this event.'
            checked={checkbox1}
            callBack={(status: boolean) => {
              setCheckbox1(status);
            }}
          />
        </li>
        <li>
          <SimpleCheckbox
            label='I understand this process can not be reversed.'
            checked={checkbox2}
            callBack={(status: boolean) => {
              setCheckbox2(status);
            }}
          />
        </li>
      </ul>

      <div>Type "{confirmWord}" to confirm</div>
      <div className='refund-confirm-word'>
        {
          confirmWord.split('').map((el, i) => (
            <span style={{ color: confirmWordInput[i] === el ? '#0094ff' : '#afafaf' }}>{el}</span>
          ))
        }
      </div>

      {isValid &&
        <span className='custom-pb-container' style={{ position: 'absolute', bottom: '1rem', right: '1rem' }}>
          <BtnLoader
            label='Confirm'
            handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
              handleRefundAll(setStatus, emailData);
            }}
          />
        </span>
      }
    </>
  );
};

type PropsType = {
  eventId: string | number
};

const SchRefaundPage = ({ eventId }: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const contextEvent = React.useContext(EventDetailContainerContext);

  const [pending, setPending] = React.useState(true);
  const [showPaymentModal, handleShowPaymentModal] = React.useState(false);
  const [showPaymentModalOrderId, handleShowPaymentModalOrderId] = React.useState(null);
  const [showRefundAllEmailModal, handleShowRefundAllEmailModal] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  const [totalRows, setTotalRows] = React.useState(0);
  const [skipCount, setSkipCount] = React.useState(0);
  const [searchInput, setSearchInput] = React.useState('');
  const [sortString, setSortString] = React.useState('creation_time+desc');
  const [currentPage, setCurrentPage] = React.useState(1);
  const [maxResultCount, setMaxResultCount] = React.useState(100);


  const fetchData = async () => {
    try {
      // eslint-disable-next-line
      setPending(true);

      const { result } = await GET(`/api/v1/1/events/${eventId}/orders?max_result_count=${maxResultCount}&skip_count=${skipCount}&order_status=30&sorting=${sortString}&search_text=${searchInput}&search_type=all`);

      setRows(result.items);
      setTotalRows(result.total_count);

      setPending(false);
    } catch (e) {
      console.log(e);
      console.error('Cant get orders');
      setPending(false);
    }
  };

  const handleRefundAll = async (setStatus: (string) => void, data) => {
    setStatus('loading');
    try {
      const { success } = await POST(`/api/v1/1/orders/${eventId}/refund_all`, data);

      if (success) {
        setStatus('success');
        fetchData(true);

        context.handleToggleHeaderBanner(true, <RefundAllBanner />);
        context.handleShowSystemDialog(true, {
          systemDialogType: 'success',
          systemDialogTitle: 'Great!',
          systemDialogContent: 'Successfully'
        });
      }
    } catch (error) {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Error'
      });

      setStatus('error');
      console.error(error);

      setTimeout(() => {
        setStatus('');
      }, 2000);
    }
  };

  const handleRefundAllConfirmation = (data: any) => {
    handleShowRefundAllEmailModal(false);
    context.handleShowSystemDialog(true, {
      systemDialogType: 'warning',
      systemDialogTitle: 'Confirm',
      systemDialogContent:
        <RefundAllModalContent
          handleRefundAll={handleRefundAll}
          confirmWord="refund"
          emailData={data}
        />
    });
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setSkipCount(page * maxResultCount - maxResultCount);
  };

  React.useEffect(() => {
      fetchData();
  }, [eventId, searchInput, skipCount, maxResultCount, sortString]);

  return (
    <section>
      <div className="panel panel-default panel-page no-border RefundPage">
        <div
          className="panel-heading-color3 navbar-page-toolbar send-mail-navbar"
          style={{ marginBottom: 0 }}
        >
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navbar-collapse-customer-database"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
          </div>

          <div className="collapse navbar-collapse" id="navbar-collapse-customer-database">
            <ul
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                margin: '0'
              }}
            >
              <li>
                <div className="" style={{ color: '#fff' }}>
                  <div className="navbar-brand">
                    <span>Issue Refund</span>
                  </div>
                </div>
              </li>

              <li>
                <div className="navbar-right" style={{ marginRight: 0, marginBottom: 0, display: 'flex', gap: '15px' }}>
                  <div className="input-group event-search green">
                    <input
                      id="tickets-search"
                      className="form-control"
                      type="text"
                      placeholder="Search"
                      value={searchInput}
                      onChange={(e: any) => {
                        setSearchInput(e.target.value);
                      }}
                    />
                    <span className="input-group-btn">
                      <i
                        className="btn btn-default btn-search"
                      >
                        <span
                          className="glyphicon glyphicon-search"
                          style={{
                            color: '#000',
                            position: 'relative',
                            top: '2px'
                          }}
                        />
                      </i>
                    </span>
                  </div>
                  <button
                    className='refund-all-btn'
                    onClick={() => {
                      handleShowRefundAllEmailModal(true);
                    }
                    }
                  >Refund all</button>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="panel-body">
          {!!_.size(rows) &&
            <p style={{ padding: '15px' }}>
                Click on the gear icon next to the payment you want to refund
            </p>
          }

          <RefundBody
            progressPending={pending}
            data={rows}
            handleShowPaymentModalOrderId={handleShowPaymentModalOrderId}
            handleShowPaymentModal={handleShowPaymentModal}
            showPaymentModal={showPaymentModal}
            handleSort={setSortString}
            maxResultCount={maxResultCount}
            setMaxResultCount={setMaxResultCount}
            currentPage={currentPage}
            totalRows={totalRows}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      {showPaymentModal &&
        <EventPageDetailCustomersPaymentModal
          isOpen={showPaymentModal}
          handleShowPaymentModal={handleShowPaymentModal}
          showPaymentModalOrderId={showPaymentModalOrderId}
          eventData={contextEvent.eventDetail}
          updateRefundList={() => fetchData(true)}
        />
      }
      {showRefundAllEmailModal &&
        <RefundAllEmailModal
          isOpen={showRefundAllEmailModal}
          handleShowModal={handleShowRefundAllEmailModal}
          handleConfirm={(data: any) => handleRefundAllConfirmation(data)}
          eventDetail={contextEvent.eventDetail}
        />
      }
    </section>
  );
};

export default SchRefaundPage;
